import React from 'react';
class StatusBar extends React.Component {
  static currentHeight = 0;
  render() {
    return null;
  }
}
export default StatusBar;
